module.exports = __webpack_public_path__ + "img/desktop-4.b9b43e7b.jpg";